import { useEffect, RefObject } from 'react';

type Props = {
    loaderRef: RefObject<HTMLDivElement | null>;
    hasNextPage?: boolean;
    isFetchingNextPage?: boolean;
    fetchNextPage: () => void;
};

export const useSuperAdminLookupInfiniteScroll = ({
    loaderRef,
    hasNextPage,
    isFetchingNextPage,
    fetchNextPage,
}: Props) => {
    useEffect(() => {
        if (!loaderRef.current || !hasNextPage || isFetchingNextPage) return;

        const scrollableContainer = loaderRef.current.closest('.overflow-y-scroll');

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    fetchNextPage();
                }
            },
            {
                root: scrollableContainer,
                rootMargin: '100px',
            },
        );

        const current = loaderRef.current;
        observer.observe(current);

        return () => observer.unobserve(current);
    }, [fetchNextPage, hasNextPage, isFetchingNextPage, loaderRef]);
};
